export { default, TableResizeHandleProps } from './TableResizeHandle';
